document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.nked-buybox').forEach((buybox) => {
    const variantInput = buybox.querySelector('.nked-buybox__variant-input');
    const sellingPlanInput = buybox.querySelector('.nked-buybox__selling-plan-input');
    const subscribeFrequency = buybox.querySelector('[data-subscribe-frequency]');
    const bundlesEl = buybox.querySelector('.nked-buybox__bundles');
    const ctaPriceRow = buybox.querySelector('[data-cta-price]');
    // selected by class, not the [data-cta-price-now] attribute — that same
    // attribute name is also used (as a per-bundle value source) on every
    // bundle radio input, and querySelector would otherwise match one of those
    // hidden inputs instead of this visible price span
    const ctaPriceNow = buybox.querySelector('.nked-buybox__cta-price-now');
    const ctaPriceWas = buybox.querySelector('.nked-buybox__cta-price-was');
    // updated on every bundle change so the "subscribe" purchase-type toggle
    // (below) always re-applies whichever bundle's plan is currently selected,
    // instead of a stale plan captured once at page load
    let sellingPlanValue = sellingPlanInput ? sellingPlanInput.value : null;

    const subscribeRadio = buybox.querySelector('input[name="purchase_type"][value="subscribe"]');
    const onetimeRadio = buybox.querySelector('input[name="purchase_type"][value="onetime"]');

    const isOnetime = () => onetimeRadio && onetimeRadio.checked;
    const checkedBundle = () => buybox.querySelector('input[name="bundle"]:checked');

    // Add to Cart button price = the currently-selected bundle's price for the
    // currently-active mode (subscribe vs. one-time), with the anchor struck out
    // when that mode is discounted.
    const updateCtaPrice = () => {
      const radio = checkedBundle();
      if (!radio || !ctaPriceNow) return;
      const ot = isOnetime();
      const price = radio.getAttribute(ot ? 'data-ot-price' : 'data-sub-price');
      const discounted = radio.getAttribute(ot ? 'data-ot-discount' : 'data-sub-discount') === 'true';
      if (price) ctaPriceNow.textContent = price;
      if (ctaPriceWas) {
        if (discounted) {
          ctaPriceWas.textContent = radio.getAttribute('data-anchor') || '';
          ctaPriceWas.hidden = false;
        } else {
          ctaPriceWas.hidden = true;
        }
      }
    };

    const applyPurchaseType = (mode) => {
      if (mode === 'subscribe') {
        if (sellingPlanInput) {
          sellingPlanInput.value = sellingPlanValue;
          sellingPlanInput.disabled = false;
        }
        if (bundlesEl) bundlesEl.classList.remove('nked-buybox__bundles--onetime');
      } else {
        if (sellingPlanInput) sellingPlanInput.disabled = true;
        if (bundlesEl) bundlesEl.classList.add('nked-buybox__bundles--onetime');
      }
      updateCtaPrice();
    };

    // Marketing links can preselect a bundle via ?variant=<id> (Shopify's
    // standard variant query param). Setting .checked on a radio input
    // natively un-checks the rest of its named group, so this just needs to
    // run before the initial "if (radio.checked) applyBundle()" pass below.
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) {
      const targetRadio = buybox.querySelector(`input[name="bundle"][value="${urlVariant}"]`);
      if (targetRadio) targetRadio.checked = true;
    }

    buybox.querySelectorAll('input[name="bundle"]').forEach((radio) => {
      const applyBundle = () => {
        if (variantInput) variantInput.value = radio.value;

        const planId = radio.getAttribute('data-selling-plan-id');
        const planLabel = radio.getAttribute('data-selling-plan-label');
        if (planId) {
          sellingPlanValue = planId;
          if (sellingPlanInput && !sellingPlanInput.disabled) {
            sellingPlanInput.value = planId;
          }
        }
        if (planLabel && subscribeFrequency) {
          subscribeFrequency.textContent = planLabel;
        }
        updateCtaPrice();
      };

      const selectBundle = () => {
        if (radio.checked) applyBundle();
      };

      // 'change' covers keyboard selection; 'click' also fires when re-clicking
      // the already-selected card (which 'change' does not).
      radio.addEventListener('change', selectBundle);
      radio.addEventListener('click', selectBundle);
      if (radio.checked) applyBundle();
    });

    buybox.querySelectorAll('input[name="purchase_type"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.checked) applyPurchaseType(radio.value === 'subscribe' ? 'subscribe' : 'onetime');
      });
    });

    // Gallery: click a thumbnail -> swap the main image, mark it active, and
    // scroll the strip so the active thumb stays centered.
    const gallery = buybox.querySelector('[data-gallery]');
    if (gallery) {
      const mainImg = gallery.querySelector('[data-gallery-main]');
      const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      let loadToken = 0;

      // preload every full-size image once the page is idle so selecting a
      // thumb swaps instantly instead of waiting on a cold fetch
      const preloadFulls = () => {
        thumbs.forEach((thumb) => {
          const full = thumb.getAttribute('data-full');
          if (full) {
            var im = new Image();
            im.src = full;
          }
        });
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preloadFulls, { timeout: 3000 });
      } else {
        setTimeout(preloadFulls, 1200);
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
          thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });

          const full = thumb.getAttribute('data-full');
          const small = thumb.querySelector('img');
          if (!full || !mainImg) return;
          const token = ++loadToken;
          // show the already-loaded thumbnail immediately (no blank frame),
          // then upgrade to the full image the moment it's ready
          if (small) mainImg.setAttribute('src', small.src);
          const hi = new Image();
          hi.onload = () => {
            if (token === loadToken) mainImg.setAttribute('src', full);
          };
          hi.src = full;
        });
      });
    }

    // Accordions: one open at a time — opening one closes any other that's open.
    const accordions = buybox.querySelectorAll('.nked-buybox__accordion');
    accordions.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        accordions.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      });
    });

    // Social-proof photos: tap to open a small lightbox. Close via the X,
    // a click outside the image, or Escape.
    const spModal = buybox.querySelector('[data-sp-lightbox-modal]');
    if (spModal) {
      const spImg = spModal.querySelector('.nked-sp-lightbox__img');
      let spLastFocus = null;

      const spOpen = (src) => {
        spImg.setAttribute('src', src);
        spModal.hidden = false;
        document.body.style.overflow = 'hidden';
        const closeBtn = spModal.querySelector('.nked-sp-lightbox__close');
        if (closeBtn) closeBtn.focus();
      };
      const spClose = () => {
        spModal.hidden = true;
        spImg.setAttribute('src', '');
        document.body.style.overflow = '';
        if (spLastFocus) spLastFocus.focus();
      };

      buybox.querySelectorAll('[data-sp-lightbox]').forEach((btn) => {
        btn.addEventListener('click', () => {
          spLastFocus = btn;
          spOpen(btn.getAttribute('data-sp-lightbox'));
        });
      });

      // Close on: the X button, or a click on the overlay outside the image frame.
      const spCloseEls = [spModal].concat(
        Array.prototype.slice.call(spModal.querySelectorAll('[data-sp-lightbox-close]'))
      );
      spCloseEls.forEach((el) => {
        el.addEventListener('click', (e) => {
          if (el === spModal && e.target !== spModal) return; // click was inside the frame
          spClose();
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !spModal.hidden) spClose();
      });
    }

    // AJAX add-to-cart: update + open the cart drawer instead of a full-page
    // navigation to /cart (that page now redirects home - the drawer is the
    // only cart surface). This form has no Dawn <product-form> markup
    // (no .loading__spinner), so it uses a plain handler rather than Dawn's
    // product-form.js, which throws on that missing element.
    const addForm = buybox.querySelector('form.nked-buybox__form');
    if (addForm) {
      addForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const submitBtn = addForm.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        const cartDrawer = document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(addForm);
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          formData.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('NKED add-to-cart error:', response.description || response.message);
              return;
            }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          })
          .catch((err) => console.error('NKED add-to-cart failed:', err))
          .finally(() => {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  });
});
